import './index.css';

import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import { enableMocking } from './mock';
import { bootstrapIntegrations } from './libs/integrations/bootstrap';

bootstrapIntegrations();

enableMocking().then(async () => {
  const container = document.getElementById('root');
  if (!container) {
    throw new Error('Missing #root element');
  }

  createRoot(container).render(
    <StrictMode>
      <App />
    </StrictMode>
  );
});
